export interface BonusEntitlement {
    from: Date;
    content: string;
    type: BonusEntitlementType;
}

export enum BonusEntitlementType {
    UNKNOWN = "UNKNOWN",
    STORY = "STORY",
    ACTIVITY = "ACTIVITY"
}